import React, { Component, Fragment } from "react";
import FlexView from "react-flexview";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import M from "moment";
import * as R from "ramda";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  removeNullFields,
} from "../../../common/mapper";
import SimpleInput from "../../../../modules/SimpleInput";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { formGroupBBNLeasing, initialData, tableColumns } from "./config";
import PenyerahanBBNLeasingFilter from "./penyerahanBBNLeasingFilter";
import PenyerahanBBNLeasingModifying from "./penyerahanBBNLeasingModifying";
import Api from "../../../../Services/Api";

class PenyerahanBBNLeasing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filterModalVisible: false,
      modifyingModalVisible: false,
      action: null,
      tableColumns: [
        ...tableColumns.firstPage,
        {
          name: "",
          label: "Action",
          options: {
            customBodyRender: (_, tableMeta) => {
              return (
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleButton
                    category="action_button"
                    style={{ backgroundColor: "transparent" }}
                    icon={
                      <i
                        style={{ fontSize: 20, color: "red" }}
                        className="fa fa-lg fa-eye"
                      />
                    }
                    onClick={() =>
                      this.handleModifyingModalVisibility(
                        tableMeta.rowIndex,
                        "view"
                      )
                    }
                  />
                  <SimpleButton
                    category="action_button"
                    style={{ backgroundColor: "transparent" }}
                    icon={
                      <i
                        style={{ fontSize: 20, color: "red" }}
                        className="fa fa-lw fa-pencil-alt"
                      />
                    }
                    onClick={() =>
                      this.handleModifyingModalVisibility(
                        tableMeta.rowIndex,
                        "edit"
                      )
                    }
                  />
                </FlexView>
              );
            },
            sort: false,
          },
        },
      ],
      search: { ...initialData.search },
      filterData: { ...initialData.filter },
      dataCabang: [],
      dataTable: [],
      pagination: {
        count: 10,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  componentDidMount = async () => {
    this.setLoading(true);
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        startPeriod: M(new Date()).format("DD-MM-YYYY"),
        endPeriod: M(new Date()).format("DD-MM-YYYY"),
      },
    }));
    await this.fetchData({
      startPeriod: M(new Date()).format("DD-MM-YYYY"),
      endPeriod: M(new Date()).format("DD-MM-YYYY"),
      kodeCabang: this.props.selectedCabang?.value,
      limit: this.state.pagination.limit,
      page: 1,
    });
    this.setLoading(false);
  };

  componentDidUpdate = async (prevProps) => {
    if (this.props.selectedCabang !== prevProps.selectedCabang) {
      this.setLoading(true);
      this.setState((prevState) => ({
        ...prevState,
        search: {
          ...prevState.search,
          kodeCabang: this.props.selectedCabang,
          startPeriod: M(new Date()).format("DD-MM-YYYY"),
          endPeriod: M(new Date()).format("DD-MM-YYYY"),
        },
        filterData: {
          ...prevState.filterData,
          kodeCabang: this.props.selectedCabang,
        },
        pagination: {
          count: 0,
          limit: 5,
          page: 1,
        },
      }));

      await this.fetchData({
        // ...removeNullFields(this.parseFilterData(this.state.search)),
        startPeriod: M(new Date()).format("DD-MM-YYYY"),
        endPeriod: M(new Date()).format("DD-MM-YYYY"),
        kodeCabang: this.props.selectedCabang?.value,
        limit: this.state.pagination.limit,
        page: 1,
      });
      this.setLoading(false);
    }
  };

  buildRequestBody = (override = {}) => {
    const { pagination, filterData, search } = this.state;

    const filterRequest = removeNullFields(
      this.parseFilterData(filterData)
    );

    const searchRequest = removeNullFields(
      this.parseFilterData(search)
    );

    const paramFilters = !R.isEmpty(filterRequest)
      ? filterRequest
      : searchRequest;

    return {
      ...paramFilters,
      kodeCabang: this.props.selectedCabang?.value,
      page: pagination.page,
      limit: pagination.limit,
      ...override,
    };
  };

  handleModalFilterVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      selectedCabang: this.state.search.kodeCabang,
      filterModalVisible: !prevState.filterModalVisible,
    }));
  };

  handleModifyingModalVisibility = (index, action) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index) ? prevValue.dataTable[index] : null,
      modifyingModalVisible: !prevValue.modifyingModalVisible,
      action: action,
    }));
  };

  handleInputDateChange = (name, value) => {
    let parseValue = M(value).format("DD-MM-YYYY");
    if (R.equals("startDate", name)) {
      if (parseValue > this.state.search.endDate) {
        this.setState((prevValue) => ({
          ...prevValue,
          search: {
            ...prevValue.search,
            [name]: parseValue,
            endDate: parseValue,
          },
        }));
        return;
      }
    }

    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: parseValue,
      },
    }));
  };

  handleValueChangeSearch = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: value,
      },
    }));
  };

  handleClearSearch = () => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        ...initialData.search,
      },
    }));
  };

  handleSubmitSearch = async () => {
    this.setLoading(true);
    this.setState((prevState) => ({
      ...prevState,
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
      },
    }),async ()=>{
      const requestBody = {
        ...removeNullFields(this.parseFilterData(this.state.search)),
        kodeCabang: this.props.selectedCabang?.value,
        limit: this.state.pagination.limit,
        page: 1,
      };

      await this.fetchData(requestBody);
      this.setLoading(false);
      this.handleClearFilter();
    })
  };

  handleReset = async () => {
    this.handleTriggerLoading();
    this.handleClearSearch();
    await this.fetchData();
    this.handleTriggerLoading();
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: {
        ...prevState.filterData,
        ...initialData.filter,
      },
    }));
  };

  handleOnSubmitFilter = () => {
    this.setLoading(true);
    this.setState((prevState) => ({
      ...prevState,
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
      },
    }),async() => {
      let requestBody = {
        ...removeNullFields(this.parseFilterData(this.state.filterData)),
        kodeCabang: this.props.selectedCabang?.value,
        limit: this.state.pagination.limit,
        page: 1,
      };

      await this.fetchData(requestBody);
      this.handleClearSearch();
      this.handleModalFilterVisibility();
      this.setLoading(false);
    });
  };

  handleSubmitModifying = async (controls) => {
    this.setLoading(true);;

    let formControls = { ...flattenFormGroupObject(controls) };

    const requestBody = {
      ...formControls,
      kodeCabang: this.props.selectedCabang?.value,
      leasingId: getValueFromDDL(formControls, "leasingId"),
    };

    try {
      await Api.create("NAGAMAS_TRANSACTION")
        .savePenyerahanBBNLeasing(requestBody);

      // 🔥 refresh pakai page aktif
      const refreshBody = this.buildRequestBody();
      await this.fetchData(refreshBody);

    } catch (error) {
      console.log("error: ", error);
    }

    this.handleModifyingModalVisibility();
    this.setLoading(false);
  };

  handleChangePage = async (tableState) => {
    this.setLoading(true);
    let limit = tableState.rowsPerPage;
    let page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
      },
    }));

    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData)
    );
    const searchRequest = removeNullFields(
      this.parseFilterData(this.state.search)
    );

    let paramFilters;
    if (!R.isEmpty(filterRequest)) {
      paramFilters = {
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
      };
    } else {
      paramFilters = { ...searchRequest };
    }

    const reqBody = {
      ...paramFilters,
      page: page,
      limit: limit,
    };

    await this.fetchData(reqBody);
    this.setLoading(false);
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.setLoading(true);
    let limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        count: 1,
        page: 1,
        limit: limit,
      },
    }));

    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData)
    );
    const searchRequest = removeNullFields(
      this.parseFilterData(this.state.search)
    );

    let paramFilters;
    if (!R.isEmpty(filterRequest)) {
      paramFilters = {
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
      };
    } else {
      paramFilters = { ...searchRequest };
    }

    const requestBody = {
      ...paramFilters,
      page: 1,
      limit: limit,
    };

    await this.fetchData(requestBody);
    this.setLoading(false);
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  setLoading = (value) => {
    this.setState({ loading: value });
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
    };
  }

  fetchData = async (body) => {
    try {
      const response = await Api.create(
        "NAGAMAS_TRANSACTION"
      ).findAllPenyerahanBBNLeasing(
        body && Object.keys(body).length > 0
          ? body
          : { kodeCabang: this.props.selectedCabang?.value, page: 1, limit: 5 }
      );

      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: !R.isNil(response.data.data) ? response.data.data : [],
          pagination: {
            ...prevValue.pagination,
            count: response.data.totalData ? response.data.totalData : 0,
          },
        }));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  handleRefreshPagination = () => {
    this.setState((prevState) => ({
      ...prevState,
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
      },
    }));
  };

  render() {
    return (
      <>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <SimpleDate
              id="select_date_from"
              date={this.state.search.startPeriod}
              onChange={(value) =>
                this.handleInputDateChange("startPeriod", value)
              }
            />
            <SimpleDate
              id="select_date_to"
              backdate
              minDate={this.state.search.startPeriod}
              date={this.state.search.endPeriod}
              onChange={(value) =>
                this.handleInputDateChange("endPeriod", value)
              }
            />
            <SimpleButton
              text="Cari"
              className="margin-bottom-15px"
              onClick={this.handleSubmitSearch}
            />
          </FlexView>
          <FlexView
            vAlignContent="center"
            hAlignContent="right"
            style={{ marginBottom: "20px" }}
          >
            <SimpleInput
              type="text"
              name="stnkName"
              placeholder="Nama STNK"
              containerclassname="margin-bottom-none"
              value={this.state.search.stnkName}
              onChange={(e) =>
                this.handleValueChangeSearch(e.target.name, e.target.value)
              }
            />
            <SimpleButton
              text="Cari"
              onClick={this.handleSubmitSearch}
              className="margin-top-5px"
            />
            <SimpleButton
              text="Reset"
              onClick={this.handleReset}
              className="margin-top-5px"
            />
            <SimpleButton
              className={"btn background-red margin-top-5px"}
              styles={{ width: "unset" }}
              onClick={this.handleModalFilterVisibility}
              icon={<i className="fa fa-qrcode"></i>}
            />
          </FlexView>
        </FlexView>

        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableColumns}
          toCount={this.state.pagination.count}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          options={defaultTableChange(
            (tableState) => this.handleChangePage(tableState),
            (tableState) => this.handleChangeRowsPerPage(tableState)
          )}
          footerAdditionalButtons={
            <SimpleButton
              onClick={() =>
                this.handleModifyingModalVisibility(null, "create")
              }
              icon={<i className="fa fa-plus margin-right-10px"></i>}
              text={"Tambah"}
            />
          }
        />

        {this.state.filterModalVisible && (
          <PenyerahanBBNLeasingFilter
            selectedData={this.state.filterData}
            selectedCabang={this.props.selectedCabang}
            visible={this.state.filterModalVisible}
            onValueChange={this.handleFilterValueChange}
            onSubmit={this.handleOnSubmitFilter}
            onClearForm={this.handleClearFilter}
            onClickClose={this.handleModalFilterVisibility}
          />
        )}

        {this.state.modifyingModalVisible && (
          <PenyerahanBBNLeasingModifying
            {...this.props}
            action={this.state.action}
            formGroup={formGroupBBNLeasing}
            selectedCabang={this.props.selectedCabang}
            initialValues={this.state.selectedData}
            visible={this.state.modifyingModalVisible}
            onSubmit={this.handleSubmitModifying}
            onClickClose={this.handleModifyingModalVisibility}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default PenyerahanBBNLeasing;
